import { AxiosError } from 'axios'
import { DataTableController } from 'components/common'
import {
  MasterDataFilterForm,
  MasterDataTable,
  columns,
} from 'components/masterData'
import { FILTER_FIELD_MASTER_DATA } from 'components/masterData/masterDataFilterForm'
import { usePageAccess, useQuery } from 'hooks'
import { useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import { dowloadMasterData, importMasterData } from 'utils/api/masterDataApi'
import { filterEmptyValues } from 'utils/helpers'

const MasterData = () => {
  const { isEditor } = usePageAccess()
  const [showFilter, setShowFilter] = useState(false)
  const [selectedColumns, setSelectedColumns] = useState<string[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const { getQuery } = useQuery()

  const toggleFilterForm = () => {
    setShowFilter(!showFilter)
  }

  const handleExport = async () => {
    const filters = getQuery(FILTER_FIELD_MASTER_DATA)

    // if not filters found in URL
    if (!filters) {
      return toast.error('Filters are required to export data!', {
        duration: 3000,
      })
    }

    // filtering empty values and keys of filter
    const masterFilter = filterEmptyValues(filters)

    // if filters are present with empty values
    if (Object.keys(masterFilter).length <= 0) {
      return toast.error('Please select at least on filter to export data!', {
        duration: 3000,
      })
    }

    const loadingToast = toast.loading('Loading...', { duration: Infinity })

    try {
      await dowloadMasterData({ filters: masterFilter })
      toast.success('File will be sent to you in email!', {
        id: loadingToast,
        duration: 3000,
      })
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error?.response?.data?.errors?.msg?.runningService) {
          return toast.error(error.response.data.errors.msg.runningService, {
            id: loadingToast,
            duration: 3000,
          })
        }
      }
      toast.error('Failed to export Master Data.', {
        id: loadingToast,
        duration: 3000,
      })
    }
  }

  return (
    <>
      <Helmet>
        <title>ORMS Master Data</title>
      </Helmet>

      <DataTableController
        isEditor={isEditor}
        columns={columns}
        handleFilter={toggleFilterForm}
        showFilter={showFilter}
        handleExport={handleExport}
        handleImport={importMasterData}
        activeColumnKey="master"
        placeholder="Search by barcode and description"
        defaultSelectedColumns={selectedColumns}
        loading={loading}
      />

      {showFilter ? (
        <MasterDataFilterForm toggleFilterForm={toggleFilterForm} />
      ) : (
        <MasterDataTable
          setSelectedColumns={setSelectedColumns}
          isEditor={isEditor}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    </>
  )
}

export default MasterData
